export default "__VITE_ASSET__2180fa5b__"